import { customStyles } from "components/shared/select";
import { logistTaskTypesEnum } from "helpers/enums";
import Tooltip from "rc-tooltip";
import React from "react";

const LogistTaskSettings = ({ config, renderSelect, renderCheckbox, onChange, logistTaskSettings, roles }) => {
    const renderItem = (item, i) => {
        const onChangeItem = ({ name, value }) => {
            const newVal = logistTaskSettings.map((setting, index) => ({
                ...setting,
                ...(index === i
                    ? {
                          [name]: value,
                          ...(name === "bidRole" ? { groupId: null } : {}),
                          ...(name === "groupId" ? { bidRole: null } : {}),
                      }
                    : {}),
            }));
            onChange({ name: "logistTaskSettings", value: newVal });
        };
        const editable = roles.isTruckingOrganizationAdmin;
        return (
            <tr key={i}>
                <td className="align-middle">{i + 1}</td>
                <td className="align-middle">
                    {renderCheckbox({
                        ...config.isActive,
                        disabled: !editable,
                        value: item.isActive,
                        onChange: onChangeItem,
                    })}
                </td>
                <td className="align-middle">
                    {renderSelect({
                        ...config.bidRole,
                        disabled: !editable,
                        value: item.bidRole,
                        onChange: onChangeItem,
                        styles: { ...customStyles, menu: (styles) => ({ ...styles, zIndex: 11, width: "200px" }) },
                    })}
                </td>
                <td className="align-middle">
                    {renderSelect({
                        ...config.groupId,
                        disabled: !editable,
                        value: item.groupId,
                        onChange: onChangeItem,
                        styles: { ...customStyles, menu: (styles) => ({ ...styles, zIndex: 11, width: "200px" }) },
                    })}
                </td>
                <td className="align-middle">{item.name}</td>
                <td className="align-middle">
                    {item.type === logistTaskTypesEnum.NotificationType &&
                        renderCheckbox({
                            ...config.commentRequired,
                            disabled: !editable,
                            value: item.commentRequired,
                            onChange: onChangeItem,
                        })}
                </td>
                <td className="align-middle">
                    {item.type !== logistTaskTypesEnum.NotificationType && (
                        <Tooltip overlay={item.hoursBeforeDescription}>
                            <input
                                className="form-control form-control-xs"
                                disabled={!editable}
                                value={item.hoursBefore}
                                name={`${config.bidRole.inputProps.hoursBefore}_${i}`}
                                type="number"
                                step="1"
                                onChange={(e) => onChangeItem({ name: "hoursBefore", value: e.target.value })}
                            />
                        </Tooltip>
                    )}
                </td>
            </tr>
        );
    };

    return (
        <>
            <div className="form-group">
                <strong>Настройки задач</strong>
            </div>
            <table className="table table-xs">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Включено</th>
                        <th>Роль в заявке</th>
                        <th>Группа пользователей</th>
                        <th>Тип уведомления</th>
                        <th>Обязательный комментарий</th>
                        <th>Срок выполнения</th>
                    </tr>
                </thead>
                <tbody>
                    {logistTaskSettings.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center">
                                <h6 className="pt-3">Настройки задач отсутствуют</h6>
                            </td>
                        </tr>
                    ) : (
                        logistTaskSettings.map(renderItem)
                    )}
                </tbody>
            </table>
        </>
    );
};

export default LogistTaskSettings;
